import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchGuaranteesApplicationTimeline } from '~/store/guarantees/thunks/applicationThunks.ts';
import type { AppDispatch } from '~/store/store.ts';

type TUseClientApplicationTimelineParams = {
  effectiveApplicationId: string;
  isClientReadOnly: boolean;
};

export const useClientApplicationTimeline = ({
  effectiveApplicationId,
  isClientReadOnly,
}: TUseClientApplicationTimelineParams) => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (!isClientReadOnly || !effectiveApplicationId || effectiveApplicationId === 'new') {
      return;
    }

    void dispatch(fetchGuaranteesApplicationTimeline({ applicationId: effectiveApplicationId }));
  }, [dispatch, effectiveApplicationId, isClientReadOnly]);
};
